<!-- eslint-disable vue/no-use-v-if-with-v-for -->
<template>
  <div class="im-message-container tuwen-pc-container"
      v-loading="loading"
  >
    <div class="content-top-chat" ref="box"
      @mouseenter="mouseenter"
      @mousemove="mousemove"
      @mouseleave="mouseleave"
    >
      <div class="out" v-if="messageList.length === 0 && chatRoomEnable">
        暂无内容
      </div>

      <!-- <div class="out disabled-tips" v-if="!chatRoomEnable">{{ '聊天室暂时关闭' }}</div> -->
      <el-timeline
        class="myTimeLine myTuWenTimeLine"
        :class="{ 'isEditIng': isEditIng }"
        v-if="messageList.length > 0 && chatRoomEnable"
      >
        <!-- // <el-icon><Clock /></el-icon> -->
        <el-timeline-item
          v-for="(message, index) in messageList"
          :key="index"
          :timestamp="getMessageTime(message)"
          placement="top"
          :icon="'el-icon-timer'"
          :type="'primary'"
          :hollow="true"
          :class="{ 'scrollEndAnimation': sendEditScrollEndIndex === index }"
        >
          <el-card :class="{ 'isEditIngActive': editIndex === index }">
            <div class="message-warp" @contextmenu="contextmenu(message, index)">

              <div class="message-send-fail" v-if="isAdminstator && message.userID === userInfo.userId && message.state === 'fail'"
                 title="点击重发" @click="reSendMessage(message)">
                <svg-icon class="icon-style" icon-name="error"></svg-icon>
              </div>

              <div class="message-content">
                <span v-for="(item, index) in message.renderContent" :key="index">
                  <p :key="message.id + '_' + index" v-if="item.content" v-html="item.content"></p>
                </span>
              </div>

              <!-- 图片内容 -->
              <div class="img-content" v-if="message.imageUrl.length">
                <el-image
                  :class="'liveImg liveImg' + message.imageUrl.length"
                  v-for="(item, index) in message.imageUrl" :key="index"
                  :src="item.thumburl"
                  :preview-src-list="[item.url]"
                >
                </el-image>
              </div>

              <span class="top-icon" v-if="message.stickyTop > 0">
                置顶
                <!-- {{message.stickyTop}} -->
              </span>

            </div>
          </el-card>
        </el-timeline-item>
      </el-timeline>
    </div>
    <div class="divider"></div>
    <div class="content-bottom">
      <div class="content-bottom-feel clearfix">
        <!-- <el-popover placement="top" trigger="click" v-model="popoverVisible">
          <div class="emojis">
            <div
              class="emoji"
              v-for="emoji in emojiName"
              :key="emoji"
              @click="chooseEmoji(emoji)"
            >
              <img :src="emojiUrl + emojiMap[emoji]" />
            </div>
          </div>
          <span class="icon-button" slot="reference">
            <svg-icon class="emoji-icon" icon-name="emoji"></svg-icon
          ></span>
        </el-popover> -->

        <multi-img-select
            ref="mutiImgSelect"
            :isHideSendBtn="isEditIng"
            @directSendImg="onlySendImgs"
        >
        </multi-img-select>

        <div class="timePickerWarp">
            <!-- <span class="demonstration">修改时间</span> -->
            <!--
                :time-arrow-control="false"
             -->
              <el-date-picker
                v-show="isEditIng"
                v-model="editTime"
                type="datetime"
                placeholder="选择日期时间"
                class="timePicker"
                size="mini"
              >
              </el-date-picker>
        </div>

        <!-- <span v-show="isEditIng" class="tips">正在修改数据...</span> -->
      </div>
      <div class="content-bottom-input">
        <!--
          @keyup.enter="handleSendMsg"
         -->
        <textarea
          class="input"
          ref="input"
          type="text"
          v-model="inputMsg"
          :placeholder="inputPlaceHolder"
          :disabled="isLiveEnded || showLoginAttention"
          required="required"
        ></textarea>

        <el-button size="mini" round type="primary" class="handleSendMsgBtn" v-show="!isEditIng" @click="handleSendMsg">发送</el-button>

        <el-button size="mini" round type="danger" class="cancelEditBtn" v-show="isEditIng" @click="cancelEdit">取消修改</el-button>
        <el-button size="mini" round type="primary" class="confirmEditBtn" v-show="isEditIng" @click="confirmEdit">确认修改</el-button>

      </div>
      <div class="login-attention" v-if="showLoginAttention">
        <span>{{ '当前为游客身份，请先' }}</span>
        <a class="login-link" @click="handleLogin">{{ '登录' }}</a>
      </div>

      <context-menu id="context-menu" ref="allMenu" @ctxCancel="ctxCancel">
        <!-- <li class="ctx-item" @click="hideMsg(currentNode)">隐藏</li> -->
        <li class="ctx-item" @click="editMsg(currentNode, currentIndex)">修改</li>
        <li class="ctx-item" @click="topMsg(currentNode, currentIndex, true)">置顶</li>
        <li class="ctx-item" @click="topMsg(currentNode, currentIndex, false)" v-show="currentNode && currentNode.stickyTop > 0">取消置顶</li>
        <li class="ctx-item" @click="deleteMsg(currentNode)">删除</li>
      </context-menu>
    </div>
  </div>
</template>

<script>
import bim from './bim.js'
export default {
  name: 'tuwenMessage',
  mixins: [bim],
}
</script>

<style lang="stylus" scoped>
@import './index.styl';

.im-message-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;

  .content-top-chat {
    flex-grow: 1;
    width: 100%;
    height: 330px;
    margin: 10px 0;
    overflow: auto;
    margin: 10px 0;
    border-radius: 10px;
    padding: 14px 22px;
    color: $fontColor;
    font-size: 14px;
    position: relative;
    margin: 0;

    .out {
      color: #999;
      // margin: 50% auto;
      text-align: center;
      margin: 0!important;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  .divider {
    width: 100%;
    height: 2px;
    background-color: $lineColor;
  }

  .content-bottom {
    width: 100%;
    padding: 12px;
    height: 200px;
    position: relative;

    div.content-bottom-feel {
      width: 100%;
      text-align: left;

      .icon-button {
        cursor: pointer;

        .emoji-icon {
          width: 24px;
          height: 24px;
          fill: $emojiIconColor;
        }
        margin-right 10px
      }

      .imgUploadPc {
        display: inline-block;
        font-size: 24px;
        color: #666;
      }

      /* 修改提示 */
      .tips{
        float: right;
        margin-top: 3px;
      }

      .timePickerWarp{
        padding: 0 10px;
        text-align: center;
        border-left: 1px solid #eff2f6;
        display: inline-block;
        position: relative;
        top: -5px;

        .demonstration{
          font-size: 12px;
          margin-right: 5px;
        }

        .timePicker{
          width: 180px;
        }
      }
    }

    div.content-bottom-input {
      text-align: left;
      position: relative;
      margin: 4px auto 0;

      .input {
        color: $fontColor;
        top: 0;
        right: 0;
        width: 100%;
        height: 140px;
        padding: 4px;
        background-color: $IMThemeColor;
        font-size: 16px;
        border: none;
        outline: none;
        resize: none;
      }
    }

    .send-btn {
      width: 53px;
      height: 34px;
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      right: 16px;
    }

    .login-attention {
      width: 100%;
      position: absolute;
      top: 50%;
      transform: translate(0, -50%);

      .login-link {
        cursor: pointer;
      }
    }
  }
}

.emojis {
  height: 170px;
  max-width: 400px;
  overflow: scroll;

  .emoji {
    height: 30px;
    width: 30px;
    float: left;
    box-sizing: border-box;

    img {
      width: 30px;
      height: 30px;
    }
  }
}
</style>

<i18n>
{
	"en": {
		"Chat now": "Chat now！",
    "Type a message": "Type a message",
    "Current visitor status": "当前为游客身份，请先",
    "login": "登录",
    "Live room does not exist": "Live room does not exist",
    "join Group fail": "Join Group fail, please refresh."
	},
	"zh": {
		"Chat now": "快来互动吧！",
    "Type a message": "说点什么",
    "Current visitor status": "当前为游客身份，请先",
    "login": "登录",
    "Live room does not exist": "直播间不存在",
    "join Group fail": "加入直播聊天群失败，请刷新重试"
	}
}
</i18n>
